import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck
import { LoadingButton } from '@mui/lab';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

var JoveButton = function JoveButton(props) {
  var className = props.className,
      children = props.children,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
      onClick = props.onClick,
      startIcon = props.startIcon,
      endIcon = props.endIcon,
      disabled = props.disabled,
      loading = props.loading,
      color = props.color,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      sx = props.sx,
      popovertarget = props.popovertarget,
      type = props.type;
  var extraProps = {};

  if (startIcon) {
    extraProps['startIcon'] = startIcon;
    extraProps['loadingPosition'] = 'start';
  }

  if (endIcon) {
    extraProps['endIcon'] = endIcon;
    extraProps['loadingPosition'] = 'start';
  }

  return /*#__PURE__*/_jsx("div", {
    className: clsx(className),
    children: /*#__PURE__*/_jsx(LoadingButton, _objectSpread(_objectSpread({
      className: "w-full rounded-full font-bold",
      variant: variant,
      onClick: onClick,
      disabled: disabled,
      loading: loading,
      color: color,
      size: size,
      sx: sx
    }, extraProps), {}, {
      popovertarget: popovertarget,
      type: type,
      children: children
    }))
  });
};

export default JoveButton;